import { call, put, takeEvery } from 'redux-saga/effects';

import { upsertUserAddress, resource, getError } from 'modules/api';

import { ADD_USER_ADDRESS } from 'modules/dashboard/store/constants';
import { getUserAddresses } from 'modules/dashboard/store/actions';

export function* onAddUserAddress({ payload: meta }) {
  try {
    const request = resource(ADD_USER_ADDRESS, upsertUserAddress);
    const payload = yield call(request, meta);

    yield put(getUserAddresses());

    return payload;
  } catch (error) {
    const payload = getError(error);
    // eslint-disable-next-line no-console
    console.error(payload);
    return payload;
  }
}

export function* watchAddAddress() {
  yield takeEvery(ADD_USER_ADDRESS, onAddUserAddress);
}
